import validate from "/home/runner/work/leilakrejci/leilakrejci/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/home/runner/work/leilakrejci/leilakrejci/src/middleware/redirect.global.ts";
import manifest_45route_45rule from "/home/runner/work/leilakrejci/leilakrejci/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}